module.exports = __webpack_public_path__ + "static/media/winner-fun.89741e58.png";